// Segmented pill-style tab control for the Users & Roles page.
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

const DEFAULT_TABS = [
  { key: "members", label: "Members" },
  { key: "invite", label: "Invite" },
  { key: "roles", label: "Roles" },
  { key: "activity", label: "Activity Log" },
  { key: "flows", label: "Integration Flows" },
];

const UsersTabsBar = ({ active, onChange, tabs = DEFAULT_TABS }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const TABS = tabs;

  return (
    <Box
      role="tablist"
      aria-label="Users and roles sections"
      sx={{
        display: "inline-flex",
        gap: 0.25,
        backgroundColor: "var(--fx-canvas)",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        p: 0.4,
        mb: 2.5,
        flexWrap: "wrap",
      }}
    >
      {TABS.map((tab) => {
        const selected = active === tab.key;
        return (
          <Box
            key={tab.key}
            role="tab"
            aria-selected={selected}
            tabIndex={0}
            onClick={() => onChange(tab.key)}
            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onChange(tab.key)}
            sx={{
              px: 2,
              py: 0.7,
              borderRadius: 1.25,
              fontSize: "0.75rem",
              fontWeight: 600,
              cursor: "pointer",
              userSelect: "none",
              transition: "all 0.14s ease",
              color: selected ? "var(--fx-primary)" : "var(--fx-text-secondary)",
              backgroundColor: selected ? "var(--fx-raised)" : "transparent",
              border: selected ? "1px solid var(--fx-border-strong)" : "1px solid transparent",
              boxShadow: selected ? "var(--fx-shadow-sm)" : "none",
              "&:hover": selected ? {} : { color: 'var(--fx-text-primary)' },
              "&:focus-visible": {
                outline: `2px solid ${colors.secondary[500]}`,
                outlineOffset: 1,
              },
            }}
          >
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default UsersTabsBar;
